import { useState } from 'react'
import { RocketLaunchOutlined } from '@maas-components/icons'
import DEFAULT_THEME from '@maas-components/styles'
import { Typography } from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import i18n from 'core/common/i18n'
import { Callout, Chip } from 'core/components/Core'
import ProductDialogRelevance from './components/ProductDialogRelevance'
import * as S from './ProductRelevanceCallout.style'
import { TProductRelevanceCallout } from './ProductRelevanceCallout.types'

const ProductRelevanceCallout: React.FC<TProductRelevanceCallout> = ({
  recommendations,
  disableScoreInfo,
  onClick,
}) => {
  const [open, setOpen] = useState(false)

  const renderRecommendations = () => {
    return (
      <S.List>
        {recommendations.map(
          (recommendation, idx) =>
            recommendation && (
              <Typography
                key={idx}
                variant="body1"
                component="li"
                color="textPrimary"
                className="mb-1"
              >
                {recommendation}
              </Typography>
            )
        )}
      </S.List>
    )
  }

  return (
    <Callout
      color="primary"
      style={{
        border: '1px solid #ECECEC',
        borderLeftWidth: 4,
        borderLeftColor: 'unset',
        borderRadius: 4,
        backgroundColor: DEFAULT_THEME.palette.grey[200],
        padding: 24,
      }}
      className="d-flex flex-column align-start mb-4"
    >
      <div className="d-flex justify-between w-100">
        <Chip
          label={i18n.t('productNew.basicData.relevanceContent')}
          shape="circular"
          color="primary"
          icon={
            <RocketLaunchOutlined
              style={{
                order: 1,
                color: DEFAULT_THEME.palette.common.white,
                marginLeft: 0,
                marginRight: 9,
                marginBottom: '-3px',
              }}
            />
          }
          className="mb-2"
          style={{ paddingTop: 6, paddingBottom: 6 }}
        />
        {!disableScoreInfo && (
          <HelpOutlineIcon
            style={{ marginLeft: 4, fontSize: 24 }}
            onClick={() => {
              setOpen(true)

              if (onClick) {
                onClick()
              }
            }}
            aria-label={i18n.t('productNew.productDialogRelevance.openButtonAriaLabel')}
            className="cursor-pointer"
          />
        )}
      </div>

      {renderRecommendations()}

      <ProductDialogRelevance open={open} onClose={() => setOpen(false)} />
    </Callout>
  )
}

export default ProductRelevanceCallout
